import * as  BasketActions from './baskets.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import {Basket, DeliveryMethod, Payment} from '@kion/data-models';
import { updatePurchaseOrderNumberSuccess } from './baskets.actions';

export const BASKETS_FEATURE_KEY = 'basket';

export interface BasketsState extends EntityState<Basket> {
  error?: any;
  lastCreatedId: string|null;

  isSearching: boolean;
  searchResultIds: string[];
  deliveryMethods: DeliveryMethod[] | [],
  payments: Payment[],
  supportedPayments: Payment[],
  order?: Basket,
  redirectUrl: string,
  step: string | null
}

export const adapter: EntityAdapter<Basket> = createEntityAdapter<Basket>();

export interface BasketsPartialState {
  readonly [BASKETS_FEATURE_KEY]: BasketsState;
}

export const initialState: BasketsState = adapter.getInitialState({
  lastCreatedId: null,
  isSearching: false,
  searchResultIds: [],
  searchQuery: {},
  pagination: {
    page: 1,
    perPage: 10,
    totalPages: 0,
    count: 0,
    total: 0
  },
  deliveryMethods: [],
  payments: [],
  supportedPayments: [],
  order: null,
  redirectUrl: '',
  step: null
});

const BasketsReducer = createReducer(
  initialState,
  on(
    BasketActions.createOrFindBasketSuccess,
    BasketActions.addToBasketSuccess,
    BasketActions.setDeliveryMethodSuccess,
    BasketActions.loadByIdSuccess,
    BasketActions.addEmailToBasketSuccess,
    BasketActions.setPaymentInfoSuccess,
    BasketActions.changeQuantitySuccess,
    BasketActions.deleteEntrySuccess,
    BasketActions.transformAnonymousToPersonalSuccess,
    BasketActions.addUserReferenceSuccess,
    (state, { basket  }) => adapter.upsertOne({...basket, deliveryMode: basket.deliveryMode || null, id: window.localStorage.getItem('basketId')} , { ...state })
  ),
  on(
    BasketActions.addPromotionCodeSuccess,
    BasketActions.deletePromotionCodeSuccess,
    BasketActions.setAddressSuccess,
    BasketActions.updatePurchaseOrderNumberSuccess,
    (state, { basket  }) => adapter.upsertOne({...basket, deliveryMode: basket.deliveryMode || null, id: window.localStorage.getItem('basketId')} , { ...state })
  ),
  on(
    BasketActions.loadDeliveryDataByBasketSuccess,
    (state, { deliveryMethods  }) => {
      return {
        ...state,
        deliveryMethods: deliveryMethods
      }
    }
  ),
  on(
    BasketActions.loadPaymentMethodsSuccess,
    (state, { payments  }) => {
      return {
        ...state,
        payments: payments
      }
    }
  ),
  on(
    BasketActions.loadSupportedPaymentMethodsSuccess,
    (state, { payments  }) => {
      return {
        ...state,
        supportedPayments: payments
      }
    }
  ),
  on(
    BasketActions.finalizePaymentSuccess,
    BasketActions.placeOrderSuccess,
    (state, { order  }) => {
      return {
        ...state,
        order: order,
        redirectUrl: order.redirectUrl
      }
    }
  ),
  on(
    BasketActions.placeOrderError,
    (state, { error }) => {
      return {
        ...state,
        error: error
      };
    }
  ),
  on(
    BasketActions.checkStepSuccess,
    (state, { step }) => {
      return {
        ...state,
        step: step
      };
    }
  )
);

export function reducer(
  state: BasketsState | undefined,
  action: Action
) {
  return BasketsReducer(state, action);
}
